import type { UnknownRecord } from "./type";

export function firstProperty(obj: UnknownRecord): string | undefined {
  for (const prop in obj) {
    return prop;
  }
}

export function firstValue<V>(obj: Record<string, V>): V {
  return obj[firstProperty(obj)!];
}

export function isEmpty(obj: UnknownRecord): boolean {
  return !firstProperty(obj);
}

type Key = string | number | symbol;

export function mapObject<K extends Key, V, KM extends Key, VM>(
  obj: Record<K, V>,
  mapper: (key: K, value: V) => [KM, VM],
): Record<KM, VM> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => mapper(key as K, value as V)),
  ) as Record<KM, VM>;
}
